export default function Styles(){
  return (
    <style>
      {`
       .V1-btn{
    background:#FCBD00 !important;
    font-family: 'Josefin Sans';
    font-weight: 600;
    

}
.V1-btn:hover{
    background: rgb(253, 205, 124) !important;
}

        `}
    </style>
  );
}
